import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/TablePagination": TablePagination } } });
export default ClientProvider;
